import { createContext, useContext } from "react";
import useSyncEngine from "scenes/inflight/hooks/useSyncEngine";

const SyncContext = createContext(null);

export const SyncProvider = ({ children }) => {
    const engine = useSyncEngine();
    return <SyncContext.Provider value={engine}>{children}</SyncContext.Provider>;
};

export const useSyncContext = () => useContext(SyncContext);
